// eslint-disable-next-line import/prefer-default-export
export const ACTIVE_STATE_CLASS_NAME = 'active';
